import { useCallback } from "react";
import { useDataContext } from "../DataContext";

/**
 * Hook for managing data fetching operations
 * @returns {Object} Object containing data fetching functions
 */
export const useCatalogueData = () => {
  const dataContext = useDataContext();

  /**
   * Fetches catalogue data with filtering and pagination
   * @param {import('../types/fetchOptions').FetchCatalogueDataOptions} options - Options object containing filter and pagination parameters
   * @returns {Promise<Array>} Promise resolving to array of courses
   */
  const fetchCatalogueData = useCallback(
    async (options = {}) => {
      try {
        const result = await dataContext.fetchCatalogueData(options);
        return result;
      } catch (error) {
        console.error("Failed to fetch catalogue data:", error);
        return [];
      }
    },
    [dataContext],
  );

  return {
    fetchCatalogueData,
    fetchOtherCategories: dataContext.fetchOtherCategories,
    data: dataContext.data,
  };
};
